<template>
    <bottom-sheet v-model="shows" title="기업회원 지도" fullscreen persistent width="1080" maxWidth="95%" needsLogin eager>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-layout v-if="initiated" column justify-center class="bottom-sheet__contents h-100">
            <recruitment-view-map :place="employer.info" />
        </v-layout>
        <template v-else>
            <v-overlay absolute color="white">
                <v-progress-circular indeterminate size="100" width="5" color="primary" />
            </v-overlay>
        </template>
    </bottom-sheet>
</template>

<script>
import { initExpoEmployer } from "@/assets/variables/inits";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import RecruitmentViewMap from "@/components/client/recruitments/view/recruitment-view-map.vue";

const STEPS = {
    COMMON: { value: "COMMON", text: "기본정보" },
    FINISH: { value: "FINISH", text: "신청완료" },
};

const steps = Object.values(STEPS).map((item, index) => ({ ...item, step: index + 1 }));

export default {
    components: {
        BottomSheet,
        RecruitmentViewMap,
    },
    props: {
        employer: { type: Object, default: initExpoEmployer },
    },
    data: () => ({
        shows: false,
        initiated: false,
    }),
    watch: {
        shows() {
            if (this.shows) {
                if (this.initiated) return;
                setTimeout(() => {
                    this.initiated = true;
                }, 500);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-stepper__wrapper {
    display: flex;
    flex-direction: column;
}
</style>
